import { selectUser } from '@common-reducers/UserSelectors';
import * as React from 'react';
import { useMemo } from 'react';
import { accessFormPopupActions } from '@common/reducers/AccessFormPopupReducer';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import AccessForm, { FormState } from '../access-form/access-form';
import { clearAuthError } from '@common-reducers/UserReducer';
import { Dialog, DialogContent } from '@/components/ui/dialog';

export interface IAccessFormPopupProps {
}

export function AccessFormPopup(props: IAccessFormPopupProps) {
    const dispatch = useAppDispatch()
    const status = useAppSelector((state) => state.AccessFormPopupReducer.status);
    const user = useAppSelector(selectUser);
    const open = useMemo(() => status !== 'Closed' && !user, [status, user])
    const initialState: FormState = useMemo(() => status === 'Signup' ? FormState.Signup : FormState.Login, [status]);
    
    const closeAccessFormPopup = () => {
        dispatch(accessFormPopupActions.setStatus('Closed'));
        dispatch(clearAuthError())
    }

    return (
        <Dialog open={open} onOpenChange={(open) => !open && closeAccessFormPopup()}>
            <DialogContent
                className="max-w-md w-full p-0"
                style={{
                    backgroundColor: 'var(--color-surface, #ffffff)',
                    color: 'var(--color-text, #111827)',
                }}
            >
                <AccessForm initialState={initialState} />
            </DialogContent>
        </Dialog>
    );
}
